import { FlexColumn, LabeledData } from '@gorila-shared-ui/components';
import { Cell, Grid } from 'baseui/layout-grid';
import { User } from '../../types/users';

type Props = {
  user: User;
  fullData?: boolean;
};
export function UserDetailData({ user, fullData = false }: Readonly<Props>) {
  const labelWidth = '80px';

  return (
    <Grid
      gridColumns={12}
      gridGaps={[0, 0, 0, 8, 8]}
      gridGutters={[30]}
      gridMargins={[0]}
      behavior="fluid"
    >
      <Cell span={[12, 12, 12, 6, 6]}>
        <FlexColumn gap={0}>
          <LabeledData
            label={'Correo:'}
            content={user.email || '-'}
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Teléfono:'}
            content={user.phone || '-'}
            labelWidth={labelWidth}
          />
        </FlexColumn>
      </Cell>
      <Cell span={[12, 12, 12, 6, 6]}>
        <FlexColumn gap={0}>
          <LabeledData
            label={'Cliente:'}
            content={user.tenant?.name || '-'}
            labelWidth={labelWidth}
          />
          <LabeledData
            label={'Compañia:'}
            content={user.company?.name || '-'}
            labelWidth={labelWidth}
          />
        </FlexColumn>
      </Cell>
    </Grid>
  );
}
